// extracted by mini-css-extract-plugin
export default {"content":"feedback_content__MXuHd","button":"feedback_button__cEbG+","bannerContainer":"feedback_bannerContainer__1M-BP","bannerButton":"feedback_bannerButton__6oEYQ"};